import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Form, Button, } from 'react-bootstrap';
import Select from 'react-select';
import { ChooseComponent, useFetch, useTranslation, usePermission } from '@np/np_webcomponentlib'

import { API_BUSINESS, API_OPERATIONS } from '../../shared/consts/api'

import { EntityType, DataEntityType, EntityFormPropsWithType, initEntity, columnsIdrfspecification, columnsIdrfcharacteristictype, optionsEnumStatusDoc, TypeStatusEnum } from './OperationBalanceTypes'
import CurrencyInput from 'react-currency-input-field';


// import { ColumnWithCopyToClipboard, ColumnData } from '../../shared/entityOperations/EntityOperationsCustomFC'






export const OperationBalanceForm = ({ title, idInit, handleClose, initEntityProps }: EntityFormPropsWithType) => {

    const { canView, canCreate, canUpdate, canRemove, debugMode } = usePermission('$component_name');

    const [currentID, setCurrentID] = useState<string | null>(idInit)
    const [entity, setEntity] = useState<EntityType | DataEntityType>(initEntityProps !== undefined ? initEntityProps : initEntity)

    useEffect(() => {
        setCurrentID(idInit)
    }, [idInit])

    const [, doFetchLoad] = useFetch(
        `${API_OPERATIONS}operation/${currentID}`)//{ error: errLoad, isLoading: isLoadLoad, response: respLoad }


    
        const [, doFetchCreateUpdate] = useFetch(
            `${API_OPERATIONS}balance/replenishment`)//{ error: errCU, isLoading: isLoadCU, response: respCU }



    useEffect(() => {
        if (currentID === "") {
            return
        }
        doFetchLoad({
            method: 'GET',
            "Content-Type": "application/json"
        }).then(responce => {
            setEntity(responce.data)
            console.log(responce.data)
        })
    }, [currentID])


    const handleSave = () => {
        //сначала проверим заполненность

        var method = "POST"
        if (currentID !== "") {
            method = "PATCH"
        }

        doFetchCreateUpdate({
            method: method,
            "Content-Type": "application/json",
            data: entity
        }).then(responce => {
            console.log(responce)
            setEntity(responce.data)
            console.log("responce.result.status", responce.result.status)
            if (responce.result.status === "success") {
                handleClose();
            }
            console.log(responce.data)
        })


    }
    

    const createButtonTitle = useTranslation('createButton')
    const updateButtonTitle = useTranslation('updateButton')


    const [value, setValue] = useState<string | number>('');

    const validateValue =  (_value, name, _values): void => {

        setValue(_value);

        setEntity((prevEntity) => ({
            ...prevEntity,
            amount: isNaN(_values.float) ? 0 : _values.float,
          }));
    };


    const [valueER, setValueER] = useState<string | number>('');

    const validateValueER =  (_value, name, _values): void => {

        setValueER(_value);

        setEntity((prevEntity) => ({
            ...prevEntity,
            exchangeRate: isNaN(_values.float) ? 0 : _values.float,
          }));
    };


    return (<Card>
        <Card.Header>
            <Card.Title as='h4'>{title}</Card.Title>
        </Card.Header>
        <Card.Body className="">



        <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('business')}</Form.Label>
                <Col md={9}>
                    <ChooseComponent
                        getDisplayDescription={(seletedData: any) => {
                            return seletedData ? seletedData.name : 'Выберите...'
                        }}
                        apiUrl={`${API_BUSINESS}business/list`}
                        columns={columnsIdrfcharacteristictype}
                        selectData={(selectData: any) => {
                            setEntity((prev) => { return { ...prev, idBusiness: selectData.idUnique } })
                        }}
                        resetData={() => {
                            setEntity((prev) => { return { ...prev, idBusiness: "" } })
                        }}
                        initIDUnique={entity.idBusiness !== null ? entity.idBusiness : ""}
                    >
                        Выберите провайдера
                    </ChooseComponent>
                </Col>
            </Row>


        <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('basis')}</Form.Label>
                <Col md={9}>
                    <Form.Control type="text" placeholder={useTranslation('basis')} value={entity.basis} onChange={e => setEntity((prev) => { return { ...prev, basis: e.target.value } })} />
                </Col>
            </Row>



        <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('amount')}</Form.Label>
                <Col md={9}>
                <CurrencyInput
                id="validationCustom01"
                name="input-1"
                className={`form-control`}
                value={value}
                onValueChange={validateValue}
                placeholder="Сумма"
                prefix={''}
                decimalScale={2}
                step={1}
                groupSeparator={' '}
              />
                </Col>
            </Row>

            <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('exchangeRate')}</Form.Label>
                <Col md={9}>
                <CurrencyInput
                id="validationCustom01"
                name="input-1"
                className={`form-control`}
                value={valueER}
                onValueChange={validateValueER}
                placeholder="Курс"
                prefix={''}
                decimalScale={2}
                step={1}
                groupSeparator={' '}
              />
                </Col>
            </Row>
            
            <Row className="mb-0">
                {canCreate && currentID === "" &&
                    <Button onClick={() => { handleSave(); console.log(entity) }}> {createButtonTitle} </Button>
                }

                {canUpdate && currentID !== "" &&
                    <Button onClick={() => { handleSave(); console.log(entity) }}> {updateButtonTitle} </Button>
                }


            </Row>

        </Card.Body>
    </Card>)
}
